module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADESURBVDiNpZLREQIhDEQfjAVoB5ZgB7ZwHVnC2cHZgaVYAnbAdbD+gMMwuQN0Z/gg2WxIWDAgaZIUNIYoaXIbghE4WrkG3luCAnDOmfm9msNG/gRcRp8H4Ksucxo3ANdfBEuxm7HoeaBeeewciNbPjQr6NnUMpeDDyN//Uk97jOmY+6sMH4q4JKnbZ2Vhec9ezXGfLmdJS/UxUdIz5b4OsBoU8TWLlWPUCInz2uFk3kR6RQvLyE4s/9Xo9qMH1g5eDweAD0lSjYsDz3SDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav1IconColor.png
// module id = CCkF
// module chunks = 1